export default {
  okText: '确定',
  dismissText: '取消',
  extra: '请选择'
}



// WEBPACK FOOTER //
// ./src/components/picker/locale/zh_CN.js